/*global qq */
qq.version = "5.14.0-beta2";
